import {
    RelativeDateRangeFilter,
    RelativeDateRangeFilterResult,
} from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/RelativeDateRangeFilter";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import type { IRelativeDateRange, IRelativeDateRangeOptions } from "app/pages/sales-intelligence/types/range";

import type { IAppsFilterOptionsDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

const createUpdateDateFilter = (description: IAppsFilterOptionsDto): SearchFilterInstance => ({
    key: "updateDate",
    trackingName: "App Update Date",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.updateDate.title" },
    tooltipText: { key: "si.find_apps.filters.updateDate.tooltip" },
    filter: new FilterPanelBaseFilter<IRelativeDateRange, IRelativeDateRangeOptions>({
        options: description.updateDate,
    }),
    filterView: RelativeDateRangeFilter,
    filterResultView: RelativeDateRangeFilterResult,
});

export default createUpdateDateFilter;
